import type { AnalysisPreset } from '../types/rwanda';

export interface SeasonConfig {
  name: string;
  months: number[];
  description: string;
}

export const RWANDA_CONFIG = {
  // Rwanda bounding box
  DEFAULT_BBOX: [28.8, -2.9, 30.9, -1.0] as [number, number, number, number],
  
  // Rwanda administrative boundaries
  PROVINCES: [
    { name: 'Kigali', bbox: [29.8, -2.0, 30.2, -1.8] as [number, number, number, number] },
    { name: 'Northern', bbox: [29.0, -1.8, 30.4, -1.0] as [number, number, number, number] },
    { name: 'Southern', bbox: [29.0, -2.9, 30.9, -2.0] as [number, number, number, number] },
    { name: 'Eastern', bbox: [30.0, -2.7, 30.9, -1.0] as [number, number, number, number] },
    { name: 'Western', bbox: [28.8, -2.7, 29.8, -1.0] as [number, number, number, number] }
  ],

  // Common datasets for Rwanda
  PRIORITY_COLLECTIONS: [
    'sentinel-2-l2a',
    'landsat-c2-l2',
    'modis-terra',
    'modis-aqua'
  ],

  // Rwanda-specific analysis presets
  ANALYSIS_PRESETS: {
    agriculture: {
      name: 'Agriculture Monitoring',
      description: 'Monitor crop health and agricultural patterns',
      bands: ['B04', 'B08', 'B11', 'B12'],
      indices: ['NDVI', 'EVI', 'SAVI']
    },
    forestry: {
      name: 'Forest Monitoring',
      description: 'Track forest cover and deforestation',
      bands: ['B04', 'B08', 'B11', 'B12'],
      indices: ['NDVI', 'NBR', 'NDMI']
    },
    water: {
      name: 'Water Resources',
      description: 'Monitor water bodies and quality',
      bands: ['B03', 'B04', 'B08', 'B11'],
      indices: ['NDWI', 'MNDWI']
    }
  } as Record<string, AnalysisPreset>,

  // Seasonal configurations for Rwanda
  SEASONAL_CONFIG: {
    dry_season: {
      months: [6, 7, 8],
      name: 'Dry Season'
    },
    rainy_season: {
      months: [3, 4, 5, 10, 11],
      name: 'Rainy Season'
    }
  },

  // Add missing ENDPOINTS
  ENDPOINTS: {
    stac: import.meta.env.VITE_STAC_API || 'https://staceo.eo2cube.org',
    titiler: import.meta.env.VITE_TITILER_API || 'https://raster.eo2cube.org',
    pygeoapi: import.meta.env.VITE_PYGEOAPI || 'https://api.eo2cube.org'
  },

  // Add missing SEASONS
  SEASONS: {
    dry: {
      name: 'Dry Season',
      months: [6, 7, 8, 9],
      description: 'Main dry season'
    },
    wet1: {
      name: 'Short Rains',
      months: [10, 11, 12],
      description: 'Short rainy season'
    },
    wet2: {
      name: 'Long Rains',
      months: [3, 4, 5],
      description: 'Long rainy season'
    },
    transition: {
      name: 'Transition',
      months: [1, 2],
      description: 'Transition period'
    }
  } as Record<string, SeasonConfig>
};

// Add missing getAnalysisPreset function
export const getAnalysisPreset = (presetName: string): AnalysisPreset | undefined => {
  return RWANDA_CONFIG.ANALYSIS_PRESETS[presetName];
};